<template>
<div class="flex-list-footer">
  <div class="flex-list-footer-left">
    <slot></slot>
  </div>
  <div class="flex-list-footer-right">
    <div class="page-cont">
      <div class="page-left"></div>
      <div class="page-right">
        <ul class="el-pager">
          <!-- <li v-if="$store.state.view == 'pc'">共 {{pageCount}} 条</li> -->
          <li class="page-size" v-if="$store.state.view == 'pc'">
            <el-select size="mini" v-model="page.size" @change="sizeChange">
              <el-option label="每页10条" :value="10"></el-option>
              <el-option label="每页20条" :value="20"></el-option>
              <el-option label="每页50条" :value="50"></el-option>
              <el-option label="每页100条" :value="100"></el-option>
              <!-- <el-option label="100" :value="100"></el-option> -->
            </el-select>
          </li>
          <!-- <li>
            <el-button @click="first" size="mini" title="首页" icon="el-icon-d-arrow-left" :disabled="page.no <= 1"></el-button>
          </li> -->
          <li>
            <el-button class="next-btn" @click="prev" size="mini" title="上一页" icon="el-icon-arrow-left" :disabled="page.no <= 1"></el-button>
          </li>
          <li v-if="$store.state.view == 'pc'">
            <div class="page-no-cont">
              <div>第</div>
              <div class="page-no">
                <input v-model.number="oldPageNo" @keyup.enter="pageChange" type="number" min="1" :max="pageMax" class="el-input__inner">
              </div>
              <div>页</div>
            </div>
          </li>
          <!-- <li>
            共 {{pageMax}} 页
          </li> -->
          <li>
            <el-button class="next-btn" @click="next" size="mini" title="下一页" icon="el-icon-arrow-right" :disabled="pageMax <= page.no"></el-button>
          </li>
          <!-- <li>
            <el-button @click="last" size="mini" title="末页" icon="el-icon-d-arrow-right" :disabled="pageMax <= page.no"></el-button>
          </li> -->
        </ul>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Page',
  props: ['pageNo', 'pageSize', 'pageCount'],
  data () {
    return {
      oldPageNo: this.pageNo,
      page: {
        no: this.pageNo,
        size: this.pageSize,
        count: this.pageCount
      },
    }
  },
  methods: {
    prev(){
      if (this.page.no > 1) {
        this.go(this.page.no - 1)
        this.oldPageNo = this.page.no
      }
    },
    next(){
      if (this.page.no < this.pageMax) {
        this.go(this.page.no + 1)
        this.oldPageNo = this.page.no
      }
    },
    first(){
      if (this.page.no !== 1) {
        this.go(1)
        this.oldPageNo = this.page.no
      }
    },
    last(){
      if (this.page.no != this.pageMax) {
        this.go(this.pageMax)
        this.oldPageNo = this.page.no
      }
    },
    sizeChange () {
      this.page.no = 1;
      this.$emit('pageChange', {
        no: this.page.no,
        size: this.page.size
      })
    },
    pageChange () {
      if(this.oldPageNo <= this.pageMax && this.oldPageNo >= 1){
        if(this.oldPageNo == this.pageNo){

        }else{
          this.page.no = this.oldPageNo
          this.$emit('pageChange', {
            no: this.page.no,
            size: this.page.size
          })
        }
      }else{
        this.oldPageNo = this.pageNo;
      }
    },
    // 改变
    go (page) {
      if (this.page.no !== page) {
        this.page.no = page
        //父组件通过change方法来接受当前的页码
        this.$emit('pageChange', {
          no: this.page.no,
          size: this.page.size
        })
      }
    },
  },
  computed: {
    pageMax () {
      var num = Math.ceil(this.pageCount / this.page.size)
      if(num > 0){
        return num;
      }else{
        return 1;
      }
    }
  },
  watch: {
    pageNo () {
      this.oldPageNo = this.pageNo;
      this.page.no = this.pageNo;
    }
  }
}
</script>

<style lang="scss" type="text/css">
.flex-list-footer{
  display: flex;
  border: 1px solid #ebeef5;
  border-top: none;
  padding: 6px 0;
  .flex-list-footer-left{
    flex: 10;
    padding-left: 8px;
  }
  .flex-list-footer-right{
    padding-left: 10px;
  }
}
.line-img-cont{
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  border: 16px solid #dedede;
  .line-img-close{
    position: absolute;
    top: -10px;
    right: -10px;
    z-index: 20;
  }
}
.page-cont{
  display: flex;
  .page-left{
    flex: 10;
  }
  .page-right{
    // min-width: 490px;
    .page-right-cont{
      display: flex;
    }
    .el-input__inner{
      padding: 0 7px;
    }
    .el-pager {
      display: flex;
      .page-size{
        display: flex;
        width: 120px;
      }
    }
    .page-no-cont{
      display: flex;
      padding: 0 10px;
    }
    .page-no{
      width: 50px;
      margin: 0 4px;
      input{
        text-align: center;
      }
    }
  }
}
.page-no{
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
      margin: 0;
  }
  .el-input__inner{
    height: 28px;
    line-height: 28px;
  }
}
.next-btn{
  padding: 7px;
}
</style>